import * as yup from 'yup';
import { hasValue, validateObject } from './functions';

export const validationForm1 = yup.object().shape({
  cpf: yup.string().min(10, 'Informe os 11 números do CPF').required('Informe o CPF ').typeError('Informe os 11 números do CPF'),
  completeName: yup.string().min(7, 'Nome completo: Informe o nome completo').required('Digite o nome'),
  birthDate: yup.date().required('Insira uma data').min((new Date().getFullYear() - 94), `Insira uma data superior ao ano de ${(new Date().getFullYear() - 94)}`),
  filiation: yup.number().required().typeError('Selecione uma das opções de filiação'),
  responsible1: yup.string().when('filiation', {
    is: 1,
    then: yup.string().required(' informe a filiação 1').min(8, ' Informe o nome completo do responsavel'),
  }).nullable(),
  responsible2: yup.string(),
  sex: yup.number().required().typeError('Selecione uma das opções de sexo'),
  colorRace: yup.number().moreThan(-1, 'Selecione uma das opções de Cor/Raça').required('Selecione uma das opções de Cor/Raça'),
  nationality: yup.number().required('Selecione uma das opções de nacionalidade').moreThan(0, 'Selecione uma das opções de nacionalidade'),
  nationalityCountry: yup.number().when('nationality', {
    is: 1,
    then: yup.number().required('Informe o País de Nascimento').moreThan(0, 'Informe o País de Nascimento'),
  }),
  uf: yup.string().when('nationality', {
    is: 1,
    then:
      yup.string().required(' informe o uf de nascimento'),
  }),
  cityBorn: yup.number().when('nationality', {
    is: 1,
    then: yup.number().required(' Informe a cidade de Nascimento').moreThan(0, ' Informe a cidade de Nascimento'),
  }),
  existsDeficiencyDisorder: yup.number().default(0),
  deficiencyDisorder: yup.array().when('existsDeficiencyDisorder', {
    is: 1,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção de deficiência', value => {
      return validateObject(value); // Chama a função validateObject para realizar a validação
    }),
  }),
})

export const validationForm2 = yup.object().shape({
  cep: yup.string().when('countryResidence', {
    is: 76,
    then: yup.string().required(' Informe o cep').min(9, ' informe o cep completo')
  }).nullable(),
  areaResidence: yup.number().typeError(' Informe a zona da residência').required(' Informe a zona da residência'),
  educationLevel: yup.number().moreThan(0, ': Informe a escolaridade').required(': Informe a escolaridade'),
  typeHighSchool: yup.number().when('educationLevel', {
    is: (value) => {
      if (value > 2) {
        return true
      }
      else return false;
    },
    then: yup.number().moreThan(0, ': Informe o tipo de ensino médio cursado').required(': Informe o tipo de ensino médio cursado'),
  }).nullable(),
  especificFormations: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção de outros cursos específicos', value => {
    return validateObject(value); // Chama a função validateObject para realizar a validação
  }),
  //differentiatedLocation: yup.number().typeError('Informe a localização').required('Informe uma localização'),
  course: yup
      .array()
      .when('educationLevel', {
        is: 6,
        then: yup.array().test(
          'at-least-one-filled-course',
          'Insira pelo menos um curso superior',
          (value) => {
            if (Array.isArray(value)) {
              return hasValue(value)
            };
            return false
          }
        ),
      })
      .nullable(),
    noHavePostGraduation: yup.number().required('selecione uma opção'),
    postGraduation: yup.array().when('noHavePostGraduation', {
      is: 0,
      then: yup.array().test(
        'at-least-one-filled-course',
        'Insira pelo menos uma pós Graduação',
        (value) => {
          if (Array.isArray(value)) {
            return hasValue(value)
          };
          return false
        }
      ),
    }).nullable(),
})